import { render, staticRenderFns } from "./page-login.vue?vue&type=template&id=1bd1c99e&"
import script from "./page-login.vue?vue&type=script&lang=js&"
export * from "./page-login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports